'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresReservationShoppingTabsItemController = function () {
    function WinresReservationShoppingTabsItemController($scope, $rootScope) {
        _classCallCheck(this, WinresReservationShoppingTabsItemController);

        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.log = (0, _utils.getLog)('[ShoppingTabsItem]');
    }

    _createClass(WinresReservationShoppingTabsItemController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            // Dependencies
            // this.winresReservationContext

            // Get:
            // getContext()
            // getContext().BusProducts
            // getContext().Destination

            if (this.phase) {
                this.log = (0, _utils.getLog)('[ShoppingTabsItem] [' + this.phase + ']');
            }

            this.data = this.winresReservationContext.getContext();

            this.groups = this.groups.split(",");
            this.groups = _.map(this.groups, parseInt);
            // this.busProducts = this.data.BusProducts;

            var link = function link(p) {
                //if(p.Product==null) return true;
                if (p.Product.LinkingInfo == null) return true;
                if (p.Product.LinkingInfo.GroupID == null) return true;
                var link = p.Product.LinkingInfo.GroupID;
                return _this.groups.indexOf(link) != -1;
            };

            var priceSelection = function priceSelection(p) {
                if (p.PriceSelections == null) return true;
                return p.PriceSelections && p.PriceSelections[0] && p.PriceSelections[0].Amount;
            };

            this.$scope.$watch(function () {
                return _this.data.Products;
            }, function (products) {
                // this.log("Watch fired! Products:", this.data.Products);
                // this.log("Watch fired! Groups:", this.groups);

                if (_this.data.Products.length > 0) {

                    _this.Products = _.filter(_this.data.Products, function (p) {
                        return p.Product.DestinationInfo.ProductType != 'HU' && p.Product.DestinationInfo.ProductType != 'HY' && p.Product.DestinationInfo.ProductType != 'MÖ' && link(p) && p.Amount > 0 || p.Product.DestinationInfo.ProductType == 'VV' && priceSelection(p);
                    });
                    // this.log("Filtered products:" , this.Products);

                    // Sorting.
                    var nonIdProducts = [];
                    var idProducts = _.filter(_this.Products, function (product) {
                        if (product.PassengerId != null) return true;
                        nonIdProducts.push(product);
                    });

                    idProducts.sort(function (a, b) {
                        return a.PassengerId - b.PassengerId;
                    }); // Sort id products by id to avoid confusion.
                    var sortedProducts = nonIdProducts; // Sort products without id first.
                    sortedProducts = sortedProducts.concat(idProducts);
                    _this.Products = sortedProducts;

                    // Filter null products off.
                    //this.Products = _.filter(this.Products, product=>product!=null);

                    // Stack products. wip.
                    //this.stackProducts(this.Products);

                    // Force products update.
                    //this.$rootScope.$broadcast("update-products", this.Products);
                } else {
                    _this.Products = [];
                }
            }, true);

            /*
            var winres = this;
            this.$scope.$on("update-products", (event,products)=>{
                winres.$scope.$applyAsync(()=>{
                    winres.Products = products;
                })
            });
            */

            //this.$scope.$on("set-bus-loading-status", (event,status)=>this.busLoading = status);

            //if(this.extraServicesText)
            //    this.title = this.extraServicesText;
        }
    }, {
        key: 'click',
        value: function click() {
            this.winresReservationShoppingTabs.goToPhase(this.phase);
        }

        //stackProducts(){
        //var tempProducts = JSON.parse(JSON.stringify(this.Products));
        //var duplicates = [];
        //_.each(tempProducts, prod1=>{
        //    var d = 0;
        //    _.each(tempProducts, prod2=>{
        //        if(prod1.Amount!=0 && prod1.Product.DestinationInfo.ProductName==prod2.Product.DestinationInfo.ProductName && !prod2.tested)
        //            d++;
        //    });
        //    if(d>1) duplicates.push({name: prod1.Product.DestinationInfo.ProductName, Amount: d});
        //    prod1.tested = true;
        //});
        //_.each(duplicates, duplicate=>{
        //    _.map(tempProducts, tempProduct=>{
        //        if(duplicate.name===tempProduct.Product.DestinationInfo.ProductName){
        //            tempProduct.Amount+=duplicate.Amount-1;
        //            tempProduct.duplicate = true;
        //        }
        //    });
        //});
        //var filteredProducts = [];
        //var first = false;
        //_.each(tempProducts, tempProduct=>{
        //    if((first==false && tempProduct.duplicate==true) || !tempProduct.duplicate)
        //        filteredProducts.push(tempProduct);
        //    if(tempProduct.duplicate==true)
        //        first = true;
        //});
        //this.Products = filteredProducts;
        //}

    }]);

    return WinresReservationShoppingTabsItemController;
}();

WinresReservationShoppingTabsItemController.$inject = ['$scope', '$rootScope'];

function getTemplate($attrs, $sce) {
    return $attrs.templateUrl ? $sce.trustAsResourceUrl((0, _utils.getWebcomponentsUrl)($attrs.templateUrl)) : 'shopping-tabs-item';
}

getTemplate.$inject = ['$attrs', '$sce'];

_module3.default.run(['$templateCache', function ($templateCache) {
    $templateCache.put('shopping-tabs-item', require('./winresReservationShoppingTabsItem.html'));
}]);

_module3.default.component('winresReservationShoppingTabsItem', {
    templateUrl: getTemplate,
    controller: WinresReservationShoppingTabsItemController,
    require: {
        winresReservationContext: '^^winresReservationContext',
        winresReservationShoppingTabs: '^^winresReservationShoppingTabs'
    },
    bindings: {
        language: '@',
        phase: '@',
        title: '@',
        groups: '@',
        emptyText: '@',
        buttons: '@',
        notEmptyText: '@',
        extraServicesText: '@'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresReservationShoppingTabsItem/winresReservationShoppingTabsItem.js
// module id = 397
// module chunks = 2